import SaveButton from "../../../components/SaveButton";
import TextInput from "../../../components/TextInput";
import { validateMassUpload } from "../../../actions/Utilities/Entity";
import { useState, useReducer, useEffect } from "react";
import reducer from "./reducer";
import SelectInput from "../../../components/SelectInput";
import DateInput from "../../../components/DateInput";
import { toast } from "../../../components/toastNotification";
import { useQueryClient } from "react-query";

export const MassUploadExpandedRowShow = ({
  data,
  isEdit = false,
  updateRow,
  setShowEdit,
  setOrigData,
  setAllData,
  origData,
  setValidData,
  setInvalidData,
  setShow,
  initialState,
  loboptions,
  setDisplayNote,
  selectedTab,
  handleSelectedTab,
}) => {
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState(data);
  const [updatedRow, setUpdatedRow] = useState([]);
  const [isEdited, setIsEdited] = useState(false);
  const handleChange = (event, field) => {
    var editedForm = { ...formData, [event.target.name]: event.target.value };
    setFormData(editedForm);
    if (JSON.stringify(data) === JSON.stringify(editedForm)) {
      setIsEdited(false);
    } else {
      setIsEdited(true);
    }
  };
  const [state, dispatch] = useReducer(reducer, initialState);

  const handleSubmit = () => {
    validateMassUpload([
      {
        ...formData,
      },
    ]).then((res) => {
      if (res?.status === 400 || res?.status === 500) {
        toast.fire("Failed", "Invalid record update", "error");
      } else if (res) {
        formData.isValid = res[0].isValid;
        formData.findings = res[0].isValid ? "Valid" : res[0].findings;
        if (!formData.isValid) {
          toast.fire("Failed", formData.findings, "error");
        } else if (updateRow(formData)) {
          toast.fire(
            "Success",
            "The record was successfully updated",
            "success"
          );
        } else {
          toast.fire("Failed", "Invalid record update", "error");
        }
      }
    });
  };
  const [statesOptions, setStatesOptions] = useState([]);
  const [licenseTypeOptions, setlicenseTypeOptions] = useState([]);
  useEffect(() => {
    if (statesOptions.length === 0) {
      setStatesOptions(
        queryClient.getQueryData(["States"]).map((data) => {
          return { label: data.state, value: data.state };
        })
      );
    }
    if (licenseTypeOptions.length === 0) {
      setlicenseTypeOptions(
        queryClient.getQueryData(["LicenseTypes"]).map((data) => {
          return { label: data.licenseTypeName, value: data.licenseTypeId };
        })
      );
    }
  }, []);
  return (
    <div className="w-full">
      <div className="p-5 space-y-4 border-l-6 border-primary rounded-bl-xl rounder-r-none box-shadow mb-2">
        <div className="text-xs font-medium shadow-md border border-gray-200">
          <div className="grid grid-flow-col grid-cols-5  gap-5 m-3">
            <div className="grid grid-cols-1">
              <div className="font-medium">
                Entity Name: <span className="text-red-500">*</span>
              </div>
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.entityName}
                  className="font-medium"
                  name="entityName"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium lg:text-center ">
                  {formData.entityName}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">
                State: <span className="text-red-500">*</span>
              </div>
              {isEdit ? (
                <SelectInput
                  options={statesOptions}
                  name="state"
                  value={{ label: formData.state, value: formData.state }}
                  className="font-medium"
                  onChange={(e) => {
                    formData.state = e.value;
                    handleChange({
                      target: {
                        name: "state",
                        value: e.value,
                      },
                    });
                  }}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {" "}
                  {formData.state}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">Entity EIN:</div>
              {isEdit ? (
                <TextInput
                  value={formData.entityEin}
                  className="font-medium"
                  name="entityEin"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.entityEin}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">License Number:</div>
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.licenseNumber}
                  className="font-medium"
                  name="licenseNumber"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.licenseNumber}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">License Type:</div>
              {isEdit ? (
                <SelectInput
                  options={licenseTypeOptions}
                  value={{
                    label: formData.licenseTypeName,
                    value: formData.licenseTypeId,
                  }}
                  name="licenseTypeName"
                  className="font-medium"
                  onChange={(e) => {
                    handleChange({
                      target: {
                        name: "licenseTypeName",
                        value: e ? e.label : "",
                      },
                    });
                    formData.licenseTypeName = e ? e.label : "";
                  }}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.licenseTypeName}
                </div>
              )}
            </div>
          </div>

          <div className="grid grid-flow-col grid-cols-5  gap-5 m-3">
            <div className="grid grid-cols-1">
              <div className="font-medium ">Expiration Date:</div>
              {isEdit ? (
                <DateInput
                  value={
                    new Date(formData.expirationDate) == "Invalid Date"
                      ? ""
                      : new Date(formData.expirationDate)
                          .toISOString()
                          .split("T")[0]
                  }
                  className="font-medium"
                  name="expirationDate"
                  onChange={(e) => {
                    e.target.name = "expirationDate";
                    handleChange(e);
                  }}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.expirationDate}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">DRPL1:</div>
              {isEdit ? (
                <TextInput
                  value={formData.drlp1}
                  className="font-medium"
                  name="drlp1"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.drlp1}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">DRPL1 License Type:</div>
              {isEdit ? (
                <SelectInput
                  options={licenseTypeOptions}
                  value={{
                    label: formData.drlp1licenseType,
                    value: formData.drlp1licenseType,
                  }}
                  className="font-medium"
                  name="drlp1licenseType"
                  onChange={(e) => {
                    handleChange({
                      target: {
                        name: "drlp1licenseType",
                        value: e ? e.value : "",
                      },
                    });
                    formData.drlp1licenseType = e ? e.value : "";
                  }}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.drlp1licenseType}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">DRPL1 Expiration Date:</div>
              {isEdit ? (
                <DateInput
                  value={
                    new Date(formData.drlp1expDate) == "Invalid Date"
                      ? ""
                      : new Date(formData.drlp1expDate)
                          .toISOString()
                          .split("T")[0]
                  }
                  className="font-medium"
                  name="drlp1expDate"
                  onChange={(e) => {
                    e.target.name = "drlp1expDate";
                    handleChange(e);
                  }}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.drlp1expDate}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">DRPL1 License Number:</div>
              {isEdit ? (
                <TextInput
                  value={formData.drlp1licenseNumber}
                  className="font-medium"
                  name="drlp1licenseNumber"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.drlp1licenseNumber}
                </div>
              )}
            </div>
          </div>

          <div className="grid grid-flow-col grid-cols-5  gap-5 m-3">
            <div className="grid grid-cols-1">
              <div className="font-medium ">Comments:</div>
              {isEdit ? (
                <TextInput
                  value={formData.comments}
                  className="font-medium"
                  name="comments"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.comments}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">Disregarded For Tax:</div>
              {isEdit ? (
                <TextInput
                  value={formData.disregardedForTax}
                  className="font-medium"
                  name="disregardedForTax"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.disregardedForTax}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1">
              <div className="font-medium ">Notes:</div>
              {isEdit ? (
                <TextInput
                  value={formData.notes}
                  className="font-medium"
                  name="notes"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium lg:text-center">
                  {formData.notes}
                </div>
              )}
            </div>
          </div>

          <div className="grid grid-flow-col grid-cols-3  gap-5 my-3"></div>
        </div>
        {isEdit && (
          <div>
            <SaveButton
              className={isEdited ? "" : "opacity-50"}
              disabled={!isEdited}
              onClick={handleSubmit}
            />
          </div>
        )}
      </div>
    </div>
  );
};
